import { ProductFilling } from "./ProductFilling.js";

export const productFillingColorMap: Record<ProductFilling, string> = {
	[ProductFilling.ChocolateWithRaspberries]: "bg-[#7B3F61] text-white",
	[ProductFilling.ChocolateWithSaltedCaramel]: "bg-[#8B5A27] text-white",
	[ProductFilling.FruityDark]: "bg-[#4A2C54] text-white",
	[ProductFilling.FruityLight]: "bg-primary text-white",
	[ProductFilling.LemonWithRaspberries]: "bg-[#FFD75E] text-black",
	[ProductFilling.PistachioWithRaspberries]: "bg-[#A3CFA5] text-black",
};
